import { Media } from '../Model/MediaModel'
import { ItemType, PlaylistItems } from '../Model/PlaylistModel'
import config from './config'

const MIN_SEC = config.FEATURE.MIN_SECONDS

/**
 * Converte uma Media em um item de playlist, aplicando a regra de negócio
 * de tipo e duração padrão (vídeo usa a própria duração; imagem usa MIN_SECONDS).
 *
 * Fonte única usada tanto pelo "Adicionar à playlist" (tela de Mídias) quanto
 * pelo painel rápido — evita duplicar a regra.
 */
export function mediaToPlaylistItem(media: Media, order: number): PlaylistItems {
  const type: ItemType = media.type.startsWith('video') ? 'video' : 'image'
  return {
    type,
    data: media,
    _mediaId: media.id,
    seconds: type === 'video' ? media.sec : MIN_SEC,
    order,
  }
}
